import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CModalValidationStepComponent } from './c-modal-validation-step.component';



@NgModule({
  declarations: [CModalValidationStepComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CModalValidationStepComponent]
})
export class CModalValidationStepModule { }
